import { IModalContextModel } from "../../../../../../core/modalZ/interfaces/IModalContextModel";
import { BaseModel } from "../../../../../../core/util/BaseModel";
import { SingleFormModel } from "../../../../forms/singleFormModel/SingleForm_model";
import ProjectsApi, { ProjectsApi as IProjectsApi } from "../../../../../../services/api/v2/projects/Projects.api";
import OrganisationsApi, {
  OrganisationsApi as IOrganisationsApi
} from "../../../../../../services/api/v2/organisations/Organisations.api";
import { ILocalStorageService } from "../../../../../../services/local/localStorageService/ILocalStorageService";
import ToasterService, { IToasterService } from "../../../../../../core/toaster/ToasterService";
import { action, makeObservable, observable } from "mobx";
import ProgressIndicatorModel, {
  ProgressIndicatorModel as IProgressIndicatorModel
} from "../../../../../../components/widgets/ProgressIndicator/ProgressIndicator_model";
import { IOrganisationPermission } from "../../../../../../contexts/permissions/PermissionsTypes";
import LocalStorageService from "../../../../../../services/local/localStorageService/LocalStorageService";
import I18n from "../../../../../../core/localization/I18n";
import { UiActionRenderers } from "../../../../../../core/uiAction/IUiAction";
import { ButtonTypes } from "../../../../../../components/ui/Button";
import ModalContext from "../../../../../../core/modalZ/context/ModalContext";
import { GetCopyProjectFormFields } from "./CopyProject_fields";

export class CopyProjectModel extends BaseModel {
  formModel: SingleFormModel;
  modalService: IModalContextModel;
  projectsProvider: IProjectsApi;
  organisationsProvider: IOrganisationsApi;
  localStorageService: ILocalStorageService;
  toasterService: IToasterService;
  orgId: number;
  teamUsers;
  httpProgress: IProgressIndicatorModel;
  @observable projectId: number;
  @observable isLoading: boolean = true;
  @observable.ref project: FP.Entities.IProject;
  user: FP.Entities.IUser;
  refreshClaims: () => void;
  organisations: Dictionary<IOrganisationPermission>;
  constructor(
    organisationId: number,
    projectId: number,
    user: FP.Entities.IUser,
    refreshClaims: () => void,
    organisations: Dictionary<IOrganisationPermission>
  ) {
    super();
    makeObservable(this);
    this.user = user;
    this.orgId = organisationId;
    this.httpProgress = ProgressIndicatorModel;
    this.organisationsProvider = OrganisationsApi;
    this.projectsProvider = ProjectsApi;
    this.organisations = organisations;
    this.refreshClaims = refreshClaims;
    this.projectId = projectId;
    this.localStorageService = LocalStorageService;
    this.toasterService = ToasterService;
    this.formModel = new SingleFormModel();
    this.setForms();
  }

  @action
  setForms = () => {
    this.formModel.formFields = GetCopyProjectFormFields(
      this.orgId,
      this.organisationsProvider,
      this.project,
      this.organisations
    );
    this.formModel.actions = [
      {
        id: "confirmCopy",
        label: I18n.t("phrases.copy"),
        rendersIn: UiActionRenderers.BUTTON,
        componentProps: {
          type: ButtonTypes.PRIMARY,
          className: "float-right ml-2 mb-5"
        },
        onAction: async () => {
          const result = await this.formModel.submit();

          if (!result) return;

          const copyProjectPayload: FP.Entities.ICopyProject = {
            sourceProjectId: this.projectId,
            targetOrganisationId: result.targetOrganisationId,
            startDate: result.startDate,
            shouldCloneMilestones: result.shouldCloneMilestones,
            shouldCloneAudiences: result.shouldCloneAudiences,
            shouldCloneImpacts: result.shouldCloneImpacts,
            shouldCloneImpactGroups: result.shouldCloneImpactGroups,
            shouldClonePhasesAndPulses: result.shouldClonePhasesAndPulses,
            shouldCloneActions: result.shouldCloneActions
          };
          console.log(copyProjectPayload);

          try {
            await this.projectsProvider.copyProject(this.orgId, this.projectId, copyProjectPayload);
            ModalContext.hide();
          } catch (error) {
            console.error("Project copy failed:", error);
          }
        }
      },
      {
        id: "cancel",
        label: I18n.t("phrases.cancel"),
        rendersIn: UiActionRenderers.BUTTON,
        componentProps: {
          type: ButtonTypes.LINK,
          className: "float-right mb-5"
        },
        onAction: ModalContext.hide
      }
    ];
  };
}
